import React from 'react';
import { useDarkMode } from '../../../context/DarkModeContext';
import { TagIcon, PlusIcon, TrendingUpIcon, UsersIcon, DollarSignIcon, MoreHorizontalIcon, CopyIcon, PauseIcon, TrashIcon } from 'lucide-react';
import BackButton from '../../../components/UI/BackButton';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import { useRoleTheme } from '../../../hooks/useRoleTheme';
const DiscountCodes = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const stats = [{
    label: 'Active Codes',
    value: '3',
    icon: TagIcon,
    color: 'text-blue-500',
    bg: 'bg-blue-100'
  }, {
    label: 'Total Uses',
    value: '142',
    icon: UsersIcon,
    color: 'text-purple-500',
    bg: 'bg-purple-100'
  }, {
    label: 'Revenue Impact',
    value: '$2,450',
    icon: DollarSignIcon,
    color: 'text-green-500',
    bg: 'bg-green-100'
  }];
  const codes = [{
    id: 1,
    code: 'WELCOME20',
    discount: '20% OFF',
    usage: '45/100',
    dates: 'Oct 1 - Oct 31',
    status: 'Active',
    sales: '$850'
  }, {
    id: 2,
    code: 'SPOOKY5',
    discount: '$5.00 OFF',
    usage: '89/Unlimited',
    dates: 'Oct 15 - Nov 1',
    status: 'Active',
    sales: '$1,200'
  }, {
    id: 3,
    code: 'LAUNCHDAY',
    discount: '15% OFF',
    usage: '8/50',
    dates: 'Nov 15 - Nov 16',
    status: 'Scheduled',
    sales: '$0'
  }, {
    id: 4,
    code: 'SUMMERREADS',
    discount: '10% OFF',
    usage: '156/Unlimited',
    dates: 'Jun 1 - Aug 31',
    status: 'Expired',
    sales: '$2,100'
  }];
  return <div className={`min-h-screen py-8 ${dk.page}`} data-id="element-18939" data-mp="t9itsmq2bsop">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18940" data-mp="ya6k166gw5hv">
        <div className="flex justify-between items-center mb-8" data-id="element-18941" data-mp="y7kefc35002a">
          <div className="flex items-center gap-4" data-id="element-18942" data-mp="138zyb0tkw0j3">
            <BackButton data-id="element-18943" data-mp="dk2wxk7na0s8" />
            <h1 className={`text-3xl font-bold ${dk.textHeading}`} data-id="element-18944" data-mp="dle31qokbkmi">
              Discount Codes
            </h1>
          </div>
          <button className={`px-4 py-2 rounded-md transition-colors flex items-center text-white ${rt.primaryButton}`} data-id="element-18945" data-mp="8n2t7fy9pa4a">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-18946" data-mp="ijp8zqbqlazg" />
            Create New Code
          </button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-18947" data-mp="w9iz0byza1ar">
          {stats.map(stat => <div key={stat.label} className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-18948" data-mp="rb7qq5obzyun">
              <div className="flex items-center justify-between mb-4" data-id="element-18949" data-mp="166nmqg8h24to">
                <div className={`p-3 rounded-lg ${darkMode ? 'bg-gray-700' : stat.bg}`} data-id="element-18950" data-mp="11aouuinxq4oi">
                  <stat.icon className={`h-6 w-6 ${darkMode ? 'text-gray-300' : stat.color}`} data-id="element-18951" data-mp="3827sysbtm74r" />
                </div>
                <span className="text-xs font-medium text-green-600 flex items-center bg-green-100 dark:bg-green-900/30 px-2 py-1 rounded-full" data-id="element-18952" data-mp="1ikkerrpaw3pe">
                  <TrendingUpIcon className="h-3 w-3 mr-1" data-id="element-18953" data-mp="18tfzsrzmkiuk" />
                  +12%
                </span>
              </div>
              <h3 className={`text-sm font-medium ${dk.textMuted}`} data-id="element-18954" data-mp="1drzkyq6e9qlv">
                {stat.label}
              </h3>
              <p className={`text-2xl font-bold mt-1 ${dk.textPrimary}`} data-id="element-18955" data-mp="zrotpm16aa06">
                {stat.value}
              </p>
            </div>)}
        </div>

        {/* Codes Table */}
        <div className={`rounded-xl shadow-sm overflow-hidden border ${dk.card}`} data-id="element-18956" data-mp="pvdiz0h8ds7u">
          <div className="overflow-x-auto" data-id="element-18957" data-mp="uuq2bb8w8h5o">
            <table className={`min-w-full divide-y ${dk.divider}`} data-id="element-18958" data-mp="uvrghol7hjrm">
              <thead className={darkMode ? 'bg-gray-750' : 'bg-gray-50'} data-id="element-18959" data-mp="2k9wiqvae1hm6">
                <tr data-id="element-18960" data-mp="2p7y1tg7tdgxn">
                  {['Code Name', 'Discount', 'Usage', 'Valid Dates', 'Status', 'Sales', 'Actions'].map((h, i) => <th key={h} className={`px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider ${i === 6 ? 'text-right' : 'text-left'}`} data-id="element-18961" data-mp="g3yz8jf9g9fc" data-mpi={i}>
                      {h}
                    </th>)}
                </tr>
              </thead>
              <tbody className={`divide-y ${dk.divider}`} data-id="element-18962" data-mp="1drgs3p96qen">
                {codes.map(code => <tr key={code.id} data-id="element-18963" data-mp="3sk2j03601x7k">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-18964" data-mp="3ol3hytne2kle">
                      <div className="flex items-center" data-id="element-18965" data-mp="3oiquk0yv3i0y">
                        <span className={`font-mono font-bold px-2 py-1 rounded ${rt.badge}`} data-id="element-18966" data-mp="3jk5ty0fp6wbz">
                          {code.code}
                        </span>
                        <button className={`ml-2 ${dk.textFaint} hover:${dk.textSecondary}`} title="Copy Code" data-id="element-18967" data-mp="1u43ihcpnbi5k">
                          <CopyIcon className="h-3 w-3" data-id="element-18968" data-mp="24314o8zlmzle" />
                        </button>
                      </div>
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${dk.textSecondary}`} data-id="element-18969" data-mp="1bdu83fjpgk2s">
                      {code.discount}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${dk.textSecondary}`} data-id="element-18970" data-mp="1kek0085uhqb8">
                      {code.usage}
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm ${dk.textMuted}`} data-id="element-18971" data-mp="sncfdayvhohf">
                      {code.dates}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-18972" data-mp="1zzvdnoaxpl13">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold ${rt.badgeRadius} ${code.status === 'Active' ? 'bg-green-100 text-green-800' : code.status === 'Scheduled' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-18973" data-mp="1zyaj3yome238">
                        {code.status}
                      </span>
                    </td>
                    <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium ${dk.textPrimary}`} data-id="element-18974" data-mp="1h1j0zsktdt0r">
                      {code.sales}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-18975" data-mp="1q30i9e9yk0r1">
                      <div className="flex justify-end space-x-2" data-id="element-18976" data-mp="1lysnp0gtjqkw">
                        <button className={`${dk.textFaint} hover:text-blue-500`} data-id="element-18977" data-mp="31ft64dzmo51t">
                          <PauseIcon className="h-4 w-4" data-id="element-18978" data-mp="2xezeb9j2e63n" />
                        </button>
                        <button className={`${dk.textFaint} hover:text-red-500`} data-id="element-18979" data-mp="34xgufylg4j5l">
                          <TrashIcon className="h-4 w-4" data-id="element-18980" data-mp="2v0lz1okgyyvj" />
                        </button>
                        <button className={`${dk.textFaint} hover:${dk.textSecondary}`} data-id="element-18981" data-mp="2v2yp6p0dsfjo">
                          <MoreHorizontalIcon className="h-4 w-4" data-id="element-18982" data-mp="3nozz09v4c59q" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};
export default DiscountCodes;